import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";

// Import required modules
import { Pagination } from "swiper/modules";

export const Collaboration = () => {
  return (
    <section className="wow fadeIn" data-wow-delay="0s">
      <div className="container">
        <div className="wrap-carousel wrap-brand wrap-brand-v2">
          <Swiper
            spaceBetween={30}
            freeMode={true}
            pagination={{ clickable: true }}
            breakpoints={{
              1366: { slidesPerView: 5, spaceBetween: 20 }, // Desktop: 5 slides
              1024: { slidesPerView: 3, spaceBetween: 20 }, // iPad Pro: 3 slides
              768: { slidesPerView: 3, spaceBetween: 15 }, // iPad mini: 3 slides
              480: { slidesPerView: 2, spaceBetween: 15 }, // Mobile: 2 slides
            }}
            modules={[Pagination]}
            className="mySwiper"
          >
            <SwiperSlide >
              <div className="brand-item-v2" >
                <img
                  className="lazyload"
                  data-src="/shopnow/images/logo2.png"
                  src="/shopnow/images/logo2.png"
                  alt="image-brand"
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="brand-item-v2">
                <img
                  className="lazyload"
                  data-src="/shopnow/images/logo3.png"
                  src="/shopnow/images/logo3.png"
                  alt="image-brand"
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="brand-item-v2">
                <img
                  className="lazyload"
                  data-src="/shopnow/images/logo4.png"
                  src="/shopnow/images/logo4.png"
                  alt="image-brand"
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="brand-item-v2">
                <img
                  className="lazyload"
                  data-src="/shopnow/images/logo5.png"
                  src="/shopnow/images/logo5.png"
                  alt="image-brand"
                />
              </div>
            </SwiperSlide>

            <SwiperSlide>
              <div className="brand-item-v2">
                <img
                  className="lazyload"
                  data-src="/shopnow/images/logo6.png"
                  src="/shopnow/images/logo6.png"
                  alt="image-brand"
                />
              </div>
            </SwiperSlide>

            {/* <SwiperSlide>
              <div className="brand-item-v2">
                <img
                  className="lazyload"
                  data-src="/shopnow/images/logo7.png"
                  src="/shopnow/images/logo7.png"
                  alt="image-brand"
                />
              </div>
            </SwiperSlide> */}
          </Swiper>

          {/* Pagination Dots */}
          <div className="sw-dots style-2 sw-pagination-brand justify-content-center"></div>
        </div>
      </div>
    </section>
  );
};
